import { defineComponent, createElementBlock, openBlock, normalizeStyle, createElementVNode, toDisplayString } from 'vue';

const _hoisted_1 = { class: "user-avatar__initials" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UserAvatar",
  props: {
    initials: {},
    size: { default: 40 },
    color: { default: "#f59d21" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "user-avatar",
        style: normalizeStyle({
          width: `${_ctx.size}px`,
          height: `${_ctx.size}px`,
          fontSize: `${Math.round(_ctx.size * 0.4)}px`,
          backgroundColor: _ctx.color
        })
      }, [
        createElementVNode("span", _hoisted_1, toDisplayString(_ctx.initials.slice(0, 2)), 1)
      ], 4);
    };
  }
});

export { _sfc_main as default };
